import React, { useEffect, useState } from "react";
// import logo from "../Assets/Images/logo.png";
import user from "../Assets/Images/user.png";
import { NavLink, useNavigate } from "react-router-dom";
import { CurrencyConverter, ApiToken, ApiEndPoint } from "../Data/Api";
import axios from "axios";
import { useLocation } from "react-router-dom";
import logo from "../Assets/Images/h-rooms-01.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedCurr,
  setBaseCurr,
  setLoginUser,
} from "../reducers/hotelActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faHome } from "@fortawesome/free-solid-svg-icons";
function NavBar() {
  const location = useLocation()
 
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Token = ApiToken();
  const baseurl = ApiEndPoint();
  const [selectedcurr, setSelectedCurrency] = useState("SAR");
  const options = [
    { value: "SAR", label: "SAR", imgSrc: "https://flagcdn.com/w320/sa.png" },
    { value: "USD", label: "USD", imgSrc: "https://flagcdn.com/w320/us.png" },
    { value: "GBP", label: "GBP", imgSrc: "https://flagcdn.com/w320/gb.png" },
    { value: "EUR", label: "EUR", imgSrc: "https://flagcdn.com/w320/eu.png" },
    { value: "PKR", label: "PKR", imgSrc: "https://flagcdn.com/w320/pk.png" },
  ];
  const userdetail = useSelector((state) => state.user.user);
  useEffect(() => {
    BaseCurrRates();
    // localStorage.setItem('DefaultCurrency', 'SAR');
    const storedCurrency = localStorage.getItem("selectedCurrency");
    if (storedCurrency) {
      setSelectedCurrency(storedCurrency); // Default currency exists, show "OK"
    } else {
      localStorage.setItem("selectedCurrency", "SAR");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    dispatch(setLoginUser(null));
    navigate("/login");
  };
  const handlecurrchange = (event) => {
    setSelectedCurrency(event.target.value);
    SelectedCurrRates(event.target.value);
    localStorage.setItem("selectedCurrency", event.target.value);
  };

  const SelectedCurrRates = (currency) => {
    var token = CurrencyConverter();
    const config = {
      method: "get",
      url:
        "https://v6.exchangerate-api.com/v6/" + token + "/latest/" + currency, // Replace with your API URL
      maxBodyLength: Infinity,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        response.data.selectedcurrency = currency;
        dispatch(setSelectedCurr(response.data));
      })
      .catch((error) => {
        dispatch(setSelectedCurr(null));
        console.error(error);
      });
  };
  const BaseCurrRates = () => {
    var token = CurrencyConverter();
    const config = {
      method: "get",
      url: "https://v6.exchangerate-api.com/v6/" + token + "/latest/SAR", // Replace with your API URL
      maxBodyLength: Infinity,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        dispatch(setBaseCurr(response.data));
      })
      .catch((error) => {
        dispatch(setBaseCurr(null));
        console.error(error);
      });
  };
  const userstatus = async () => {
    const data = {
      token: Token,
      id: userdetail.id,
    };
    try {
      const response = await axios.post(
        baseurl + "/api/check_login_customer_submit",
        data
      );
      if (response.data.status !== "success") {
        localStorage.removeItem("authToken");
        dispatch(setLoginUser(null));
        navigate("/login");
      }
     
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    userstatus();
  }, [location.pathname]);

  return (
    <>
      {/* {userdetail?.billing_Details !== "Active" && (
        <div>
        <div
          className="alert alert-warning mb-0 alert-dismissible fade show"
          role="alert"
        >
          <strong>
            Hi {userdetail.first_name}!
          </strong>{" "}
          Your billing {userdetail?.comapany_Details === "Active" ? '':'and company' } details  are currently empty please provide the necessary
          information.
          <NavLink target="blank" to="/dashboard/edit-profile">
            Click Here
          </NavLink>
          <br/>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
        </div>
      )} */}
  

      <nav className="navbar navbar-expand-lg bg-body-tertiary">
  <div className="container">
     <NavLink className="navbar-brand" to="/">
            <img src={logo} height="90" width="220" className="img-fluid" alt="logo" />
          </NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent"> 
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        {/* <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">Home</a>
        </li> */}
        <li className="nav-item">
          <NavLink className="nav-link text-black fw-normal" to="/">Home</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link text-black fw-normal" to="/about_us">About Us</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link text-black fw-normal" to="/contact_us">Contact Us</NavLink>
        </li>
        <li className="nav-item">
                <select
                  className="form-select fw-normal"
                  value={selectedcurr}
                  onChange={handlecurrchange}
                  aria-label="Default select example"
                >
                  {options.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.value}
                    </option>
                  ))}
                </select>
              </li>
         <li className="nav-item">
                <div className="nav-link d-flex gap-2 nav-user">
                  <span>
                    <img
                      src={user}
                      alt="user-image"
                      width="32"
                      className="rounded-circle"
                    />
                  </span>
                  <div className="dropdown">
                    <span
                      className="d-lg-flex flex-column "
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }} // Adding cursor to indicate clickable
                    >
                      <p
                        style={{ fontSize: ".936rem" }}
                        className="my-0 fw-bold "
                      >
                        {userdetail?.title} {userdetail?.first_name}{" "}
                        <FontAwesomeIcon icon={faAngleDown} />
                      </p>
                      {/* <p style={{ fontSize: ".765rem" }} className="my-0 text-white">Developer</p> */}
                    </span>

                    {/* Dropdown menu */}
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li>
                        <NavLink target="blank" to="/dashboard">
                          <a className="dropdown-item">Dashboard</a>
                        </NavLink>
                      </li>
                      <li>
                        <a className="dropdown-item" onClick={handleLogout}>
                          Logout
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
  
      </ul>
     
    </div>
  </div>
</nav>
    </>
  );
}
export default NavBar;
